export const SET_WEEKDAYS = (state, { data }) => {
  state.weekdays = data;
};

export const SET_TOAST = (state, { data }) => {
  state.toast = data;
};

export const UPDATE_TIME = (state, { data }) => {
  state.filterTimes[data.identity] = data.time;
};

export const UPDATE_DATE = (state, { data }) => {
  state.filterDates[data.identity] = data.date;
};

export const TOGGLE_FILTER_BUTTON = state => {
  state.filterButtonLoading = !state.filterButtonLoading;
};

export const SET_MAP_BOUNDS = (state, { data }) => {
  state.mapBounds = data;
};

export const SET_GEOJSON = (state, { data }) => {
  state.geoJSON = data;
};

export const SET_MEASUREMENT = (state, { data }) => {
  state.measurements = data;
};

export const SET_CHOROPLETH_VISIBILITY = (state, { data }) => {
  state.showChoropleth = data;
};

export const SHOW_MARKER = state => {
  state.showMarker = !state.showMarker;
};

export const SET_API_CALL_URL = (state, { data }) => {
  state.apiCallURL = data;
};

export const SET_MAP_CENTER = (state, { data }) => {
  state.mapCenter = data;
};

export const SET_MARKER_POSITION = (state, { data }) => {
  const index = state.markers.findIndex(marker => marker.id === data.id);
  state.markers[index].position = data.latLng;
};

export const SET_POINTS = (state, { data }) => {
  state.points = data;
};

export const TOGGLE_HEATMAP = state => {
  state.heatmapVisible = !state.heatmapVisible;
};

export const REFRESH_HEATMAP = state => {
  state.heatmapVisible = false;
  state.heatmapVisible = true;
};

export const TOGGLE_DRAWER = state => {
  state.drawer = !state.drawer;
};

export const TOGGLE_FILTER_DIALOG = state => {
  state.filterDialog = !state.filterDialog;
};

export const SET_HEATMAP_VISIBLE_POINTS = (state, { data }) => {
  state.heatmapVisiblePoints = data;
};

export const ADD_MARKER = (state, { data }) => {
  state.markers.push(data);
};

export const INCREMENT_MARKER_ID = state => {
  state.currentMarkerID++;
};

export const SET_MARKER_ID = (state, { data }) => {
  state.currentMarkerID = data;
};

export const TOGGLE_REVIEW_DIALOG = state => {
  state.reviewDialog = !state.reviewDialog;
};

export const TOGGLE_BARRIER_ACTIVE_STATE = (state, { data }) => {
  const index = state.markers.findIndex(barrier => barrier.id === data);

  state.markers[index].active = !state.markers[index].active;
};

export const SET_BARRIERS = (state, { data }) => {
  state.markers = data;
};

export const SET_BUDGET = (state, { data }) => {
  state.budget = data;
};
